/**
 * Where the planet is this frame: its turn, its radius, and its scale while it eases to a new size.
 * Whatever stands on the planet or floats over it (figures, name tags, gauges) places itself from it.
 */
import type * as THREE from 'three';

export interface PlanetPose {
  /** The planet's turn: a planet point p is shown at quaternion × p. */
  readonly quaternion: THREE.Quaternion;
  /** The radius of the planet's grid, before scaling. */
  radius: number;
  /** The scale it is drawn at, while it eases to a new size. */
  scale: number;
}

/** The point `lift` above the planet's radius in direction `dir` (planet space), in scene space. */
export function onPlanet(
  pose: PlanetPose,
  dir: THREE.Vector3,
  lift: number,
  out: THREE.Vector3,
): THREE.Vector3 {
  return out
    .copy(dir)
    .multiplyScalar(pose.radius + lift)
    .applyQuaternion(pose.quaternion)
    .multiplyScalar(pose.scale);
}

/** Vector `index` of a flat array of unit vectors (tile centres, corners), into `out`. */
export function dirAt(dirs: ArrayLike<number>, index: number, out: THREE.Vector3): THREE.Vector3 {
  return out.set(dirs[index * 3] ?? 0, dirs[index * 3 + 1] ?? 0, dirs[index * 3 + 2] ?? 0);
}
